import { add, sub } from 'date-fns'

export const validStartDate = sub(new Date(Date.now()), { years: 100 })
export const validEndDate = add(new Date(Date.now()), { years: 100 })

/*
 * How the console displays timestamps: ISO order, 24h clock, no separator
 * between the two halves. Display only — date *inputs* keep their own format,
 * since that one is also what the user types.
 */
const DATE_FORMAT = 'yyyy-MM-dd'
export const DATE_TIME_FORMAT = `${DATE_FORMAT} HH:mm`
/** For timestamps where the second matters — alerts, logs, status updates. */
export const DATE_TIME_SECONDS_FORMAT = `${DATE_TIME_FORMAT}:ss`
